export default __webpack_public_path__ + "static/media/encounters.92bcb867.csv";